import {
	AUTHENTICATED_ENTRY,
	REDIRECT_URL_KEY,
	UNAUTHENTICATED_ENTRY,
} from 'configs/AppConfig';

export const isStaffUser = (user) =>
	user?.role === 'admin' || user?.role === 'superadmin';

export const getDefaultAuthenticatedPath = (user) =>
	isStaffUser(user) ? '/admin/dashboard' : AUTHENTICATED_ENTRY;

export const getSafeRedirect = (value, fallback = AUTHENTICATED_ENTRY) => {
	if (!value || typeof value !== 'string') {
		return fallback;
	}

	let decoded = value;
	try {
		decoded = decodeURIComponent(value);
	} catch (error) {
		return fallback;
	}

	if (!decoded.startsWith('/') || decoded.startsWith('//')) {
		return fallback;
	}

	if (decoded === '/' || decoded === UNAUTHENTICATED_ENTRY || decoded === '/admin') {
		return fallback;
	}

	return decoded;
};

export const getLoginPathForLocation = (pathname, search = '') => {
	const isAdminArea = pathname.startsWith('/admin/');
	const loginPath = isAdminArea ? '/admin' : UNAUTHENTICATED_ENTRY;

	if (!pathname || pathname === '/') {
		return loginPath;
	}

	const redirectTarget = `${pathname}${search || ''}`;
	return `${loginPath}?${REDIRECT_URL_KEY}=${encodeURIComponent(redirectTarget)}`;
};
